import { startCase } from 'lodash';

export const ACTIONS = {
  ADD_LABEL_V1: 'add-label@v1',
  ADD_REVIEWERS_V1: 'add-reviewers@v1',
  ADD_COMMENT_V1: 'add-comment@v1',
  ADD_LABELS_V1: 'add-labels@v1',
  APPROVE_V1: 'approve@v1',
  REQUIRE_REVIEWERS_V1: 'require-reviewers@v1',
  SET_REQUIRE_APPROVAL_V1: 'set-required-approvals@v1',
  MERGE_V1: 'merge@v1',
  REQUEST_CHANGES_V1: 'request-changes@v1',
  CLOSE_V1: 'close@v1',
  UPDATE_CHECK_V1: 'update-check@v1'
};

const actionsData = {
  [ACTIONS.ADD_LABEL_V1]: {
    key: ACTIONS.ADD_LABEL_V1,
    value: 'Add Label',
    color: 'mintGreen'
  },
  [ACTIONS.ADD_REVIEWERS_V1]: {
    key: ACTIONS.ADD_REVIEWERS_V1,
    value: 'Add Reviewer',
    color: 'blueberry'
  },
  [ACTIONS.ADD_COMMENT_V1]: {
    key: ACTIONS.ADD_COMMENT_V1,
    value: 'Add Comment',
    color: 'brightTurquoise'
  },
  [ACTIONS.ADD_LABELS_V1]: {
    key: ACTIONS.ADD_LABELS_V1,
    value: 'Add Labels',
    color: 'mintGreen'
  },
  [ACTIONS.APPROVE_V1]: {
    key: ACTIONS.APPROVE_V1,
    value: 'Approve',
    color: 'jungleGreen'
  },
  [ACTIONS.REQUIRE_REVIEWERS_V1]: {
    key: ACTIONS.REQUIRE_REVIEWERS_V1,
    value: 'Require Reviewers',
    color: 'texasRose'
  },
  [ACTIONS.SET_REQUIRE_APPROVAL_V1]: {
    key: ACTIONS.SET_REQUIRE_APPROVAL_V1,
    value: 'Set Required Approval',
    color: 'crusta'
  },
  [ACTIONS.MERGE_V1]: {
    key: ACTIONS.MERGE_V1,
    value: 'Merge',
    color: 'electricViolet'
  },
  [ACTIONS.REQUEST_CHANGES_V1]: {
    key: ACTIONS.REQUEST_CHANGES_V1,
    value: 'Request Changes',
    color: 'bitterSweet'
  },
  [ACTIONS.CLOSE_V1]: {
    key: 'close@v1',
    value: 'Close',
    color: 'lipstick'
  },
  [ACTIONS.UPDATE_CHECK_V1]: {
    key: ACTIONS.UPDATE_CHECK_V1,
    value: 'Update Check',
    color: 'oliveDrab'
  }
};

/**
 * Converts action name to a displayable title
 * @example 'explain-code-experts' => 'explain Code Experts'
 * @param {String} actionName
 * @returns String
 */
function convertActionName(actionName = '') {
  const [kebabCaseActionName] = actionName.split('@');
  return startCase(kebabCaseActionName);
}

export const getActionDetails = actionName => {
  if (!actionsData[actionName]) {
    // Handle unknown actions gracefully to avoid a crash in runtime
    return {
      key: actionName,
      value: convertActionName(actionName),
      color: 'white'
    };
  }
  return actionsData[actionName];
};
